
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private breadcrumbItems = new BehaviorSubject<MenuItem[]>([]);
  breadcrumbItems$ = this.breadcrumbItems.asObservable();
  private customBreadcrumbs: MenuItem[] = []; // Store manually added breadcrumbs

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const breadcrumbs = this.createBreadcrumbs(this.route.root);
        if(this.customBreadcrumbs){
          breadcrumbs.push(...this.customBreadcrumbs);
        }
        this.breadcrumbItems.next(breadcrumbs);
      });
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: MenuItem[] = []
  ): MenuItem[] {
    const children = route?.children;
    if (children.length == 0) return breadcrumbs;

    for (const child of children) {
      const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL) url += `/${routeURL}`;

      const data = child.snapshot.data;
      const section = data['sectionBreadcrumb'];
      const sectionUrl = data['sectionBreadcrumbUrl'];
      const breadcrumb = data['breadcrumb'];
      const showParamBreadcrumb = data['showParamBreadcrumb'] !== false;

      // Add section if defined and not already added
      if (section && !breadcrumbs.some(b => b.label == section)) {
        breadcrumbs.push({ label: section, title: 'menu.' + section,  routerLink: sectionUrl?[sectionUrl]:[] });
      }

      // Add normal breadcrumb if defined
      if (breadcrumb && !breadcrumbs.some(b => b.label == breadcrumb)) {
        breadcrumbs.push({
          label: breadcrumb,
          title: 'menu.' + breadcrumb,
          routerLink: url?[url]:[]
        });
      }

      if (breadcrumb != '' && showParamBreadcrumb) {
        const params = child.snapshot.params;
        for (const [key, value] of Object.entries(params)) {
          if (!/^\d+$/.test(value) && !breadcrumbs.some(b => b.label == value)) {
            breadcrumbs.push({
              label: value,
              title: value?.replace('_', '/'),
              routerLink: [url],
            });
          }
        }
      }

      // Continue recursion
      this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  /** Add custom breadcrumb that persists across navigation */
  addCustom(breadcrumbs:MenuItem[]) {
    this.customBreadcrumbs.push(...breadcrumbs);

    // Merge current auto + custom breadcrumbs
    const currentAuto = this.breadcrumbItems.value.filter(
      b => !this.customBreadcrumbs.some(c => c.label == b.label)
    );
    this.breadcrumbItems.next([...currentAuto, ...this.customBreadcrumbs]);
  }

  clearBreadcrumb(){
    this.customBreadcrumbs = [];
  }

}
